const PAGE_ALIASES = {
  home: "ana", aile: "ana", family: "ana", familysetup: "ana", familyinvite: "ana",
  inactive: "ana", engagement: "ana", userreminder: "ana", schedulednotification: "ana",
  system: "ana", general: "ana",
  tasks: "gorev", task: "gorev", calendar: "takvim", health: "saglik",
  shopping: "alisveris", finance: "finans", documents: "belgeler", document: "belgeler",
  map: "harita", children: "cocuk", child: "cocuk",
  sharedexpenses: "harcama", expenses: "harcama", expense: "harcama",
  cooking: "nePisirsam", activity: "activity",
  usermanagement: "kullaniciYonetimi", management: "kullaniciYonetimi",
  ana: "ana", gorev: "gorev", takvim: "takvim", saglik: "saglik",
  alisveris: "alisveris", finans: "finans", belgeler: "belgeler", harita: "harita",
  cocuk: "cocuk", harcama: "harcama", chat: "chat", assistant: "assistant",
  asistan: "assistant", nepisirsem: "nePisirsam", kullaniciyonetimi: "kullaniciYonetimi",
  ozeltakvim: "ozelTakvim", ozeltakvimim: "ozelTakvim", cycle: "ozelTakvim",
  personalcalendar: "ozelTakvim",
};

const NOTIFICATION_TYPE_PAGES = {
  chat: "chat",
  chatmessage: "chat",
  shopping: "alisveris",
  task: "gorev",
  tasks: "gorev",
  taskreminder: "gorev",
  taskdone: "gorev",
  calendar: "takvim",
  calendarreminder: "takvim",
  eventreminder: "takvim",
  event: "takvim",
  appointment: "takvim",
  birthday: "takvim",
  birthdayautomation: "takvim",
  birthdaywish: "takvim",
  finance: "finans",
  sharedexpense: "harcama",
  document: "belgeler",
  documents: "belgeler",
  documentexpiry: "belgeler",
  health: "saglik",
  medicine: "saglik",
  automationhealth: "saglik",
  cycle: "ozelTakvim",
  children: "cocuk",
  child: "cocuk",
  location: "harita",
  yakinlik: "harita",
  geofence: "harita",
  bulusma: "harita",
  assistant: "assistant",
  dailysummary: "assistant",
  urgentalert: "assistant",
  weeklydigest: "assistant",
  smartinsight: "assistant",
  notificationadmin: "kullaniciYonetimi",
  engagement: "ana",
  familyannouncement: "ana",
  familystatusupdated: "ana",
  familystatusupdaterequest: "ana",
  familystatus: "ana",
  familymemberjoined: "ana",
  system: "ana",
  systemannouncement: "ana",
  scheduled: "ana",
  userreminder: "ana",
  schedulednotification: "ana",
};

const normalizeKey = (value) => String(value || "")
  .trim()
  .toLocaleLowerCase("tr-TR")
  .replace(/[^a-z0-9çğıöşü]/g, "");

export function normalizeNotificationPage(value, fallback = "ana") {
  if (value === null || value === undefined || String(value).trim() === "") return null;
  return PAGE_ALIASES[normalizeKey(value)] || fallback;
}

const flattenNotificationData = (input = {}) => {
  let nested = input?.data;
  if (typeof nested === "string") {
    try { nested = JSON.parse(nested); }
    catch { nested = null; }
  }
  return {
    ...(nested && typeof nested === "object" ? nested : {}),
    ...(input && typeof input === "object" ? input : {}),
  };
};

/**
 * Native push, web push ve uygulama içi bildirimlerin tamamı için tek hedef
 * sözleşmesi. URL en güçlü kaynaktır; eksik/eski payload'larda doğrudan alanlar
 * ve type/source/module sırasıyla geriye uyumlu fallback olarak kullanılır.
 */
export function resolveNotificationNavigation(input = {}) {
  const data = flattenNotificationData(input);
  let page = null;
  let roomId = data.roomId || data.room_id || null;
  let sourceId = data.sourceId || data.source_id || data.kaynakId || null;
  let action = data.action || null;
  let occurrenceId = data.occurrenceId || data.occurrence_id || null;

  const rawUrl = data.url || data.link || null;
  if (rawUrl) {
    try {
      const base = typeof window !== "undefined" ? window.location.origin : "https://app.aileyonetimi.com";
      const parsed = new URL(rawUrl, base);
      page = normalizeNotificationPage(parsed.searchParams.get("pushPage"), null);
      roomId = parsed.searchParams.get("roomId") || roomId;
      sourceId = parsed.searchParams.get("sourceId") || sourceId;
      action = parsed.searchParams.get("action") || action;
      occurrenceId = parsed.searchParams.get("occurrenceId") || occurrenceId;
    } catch {}
  }

  if (!page) page = normalizeNotificationPage(data.pushPage, null);
  if (!page) {
    const candidates = [
      data.type,
      data.bildirimTipi,
      data.bildirimType,
      data.tip,
      data.kaynak,
      data.source,
      data.module,
      data.modul,
    ];
    const matched = candidates.map(normalizeKey).find((key) => NOTIFICATION_TYPE_PAGES[key]);
    if (matched) page = NOTIFICATION_TYPE_PAGES[matched];
  }

  if (page === "chat" && !roomId) roomId = data.kaynakId || data.sourceId || data.source_id || null;

  return {
    page,
    roomId: roomId ? String(roomId) : null,
    sourceId: sourceId ? String(sourceId) : null,
    action: action || null,
    occurrenceId: occurrenceId ? String(occurrenceId) : null,
  };
}
